"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleColumns = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ActionMenu_1 = require("./ActionMenu");
var R = __importStar(require("../../utils/ramda"));
var handleColumns = function (_a) {
  var columnDefs = _a.columnDefs,
    rowActions = _a.rowActions,
    rowSelection = _a.rowSelection,
    _b = _a.enterprise,
    enterprise = _b === void 0 ? false : _b;
  var colDefs = columnDefs !== null && columnDefs !== void 0 ? columnDefs : [];
  if (!R.isNothing(rowActions)) {
    colDefs = R.insert(0, actionMenuColumn(rowActions), colDefs);
  }
  if (!R.isNothing(rowSelection)) {
    colDefs = R.insert(0, selectionColumn(rowSelection), colDefs);
  }
  if (!enterprise) {
    colDefs = colDefs.map(function (c) {
      return enterpriseShield(c);
    });
  } else {
    colDefs = colDefs.map(function (col) {
      return R.assoc("menuTabs", col.menuTabs ? R.reject(R.equals("columnsMenuTab"), col.menuTabs) : ["filterMenuTab", "generalMenuTab"], col);
    });
  }
  return colDefs;
};
exports.handleColumns = handleColumns;
var enterpriseShield = function (def) {
  var hasFilter = !R.isNil(def.filter) && def.filter !== false || def.type === "date";
  def.rowGroup = false;
  def.aggFunc = undefined;
  def.menuTabs = hasFilter ? ["filterMenuTab"] : [];
  def.enableRowGroup = false;
  def.pivot = false;
  def.filterParams = __assign(__assign({}, def.filterParams), {
    suppressAndOrCondition: true
  });
  return def;
};
var selectionColumn = function (rowSelection) {
  return {
    colId: "__selection__",
    type: "__static__",
    pinned: "left",
    width: 52,
    minWidth: 52,
    maxWidth: 52,
    suppressSizeToFit: true,
    suppressAutoSize: true,
    checkboxSelection: true,
    headerCheckboxSelection: rowSelection === "multiple"
  };
};
var actionMenuColumn = function (rowActions) {
  return {
    colId: "__actions__",
    type: "__static__",
    pinned: "left",
    suppressSizeToFit: true,
    suppressAutoSize: true,
    width: 52,
    maxWidth: 52,
    minWidth: 52,
    headerName: "",
    cellRenderer: function (p) {
      var empty = !p.data || p.node.isRowPinned();
      return empty ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) : (0, jsx_runtime_1.jsx)(ActionMenu_1.ActionMenu, {
        params: p,
        rowData: p.data,
        options: rowActions
      });
    }
  };
};